// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__xNsqu","modal":"Modal_modal__tmMU8","slide-down":"Modal_slide-down__N7r6D"};